<template>
  <div class="checkout-form-group__fields">
    <div class="payment-items">
      <button v-for="item in paymentItems" @click="selectItem(item)" :key="'payment_' + item.id"
        :class="{ 'payment-item--selected': order.payment == item.id }" class="payment-items__item payment-item">
        <span :class="{ 'payment-item__check--checked': order.payment == item.id }" class="payment-item__check">
          <i v-if="order.payment == item.id" class="fa fa-circle-check payment-item__check-icon"></i>
          <i v-else class="payment-item__empty-check-icon"></i>
        </span>

        <span class="payment-item__content">
          <span class="payment-item__name">{{ item.name }}</span>
          <span class="payment-item__help-text">{{ item.help_text }}</span>
        </span>

      </button>
    </div>
  </div>
</template>


<script>
import axios from 'axios';


export default {

  name: 'CheckoutPaymentForm',

  props: {
    order: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: {}
    }
  },

  components: {

  },

  data() {
    return {
      paymentItems: null
    }
  },

  mounted() {
    this.getPaymentItems()
  },

  methods: {
    getPaymentItems() {
      axios.get(`/checkout/api/payments/`).then(
        response => {
          this.paymentItems = response.data
        }
      )
    },

    selectItem(item) {
      this.order.payment = item.payment
      this.$emit('on-select', item)
    }
  },

}
</script>


<style lang="scss"></style>
